/**
 * Auth/session actions.
 *
 * `getMe` runs the `authMe` GraphQL query — the lightweight "is my
 * session still valid?" check the app fires on every page refresh. The
 * server re-validates the JWT and the live account state (deactivated /
 * deleted accounts are rejected even if the token hasn't expired yet)
 * and returns the full user, including role-based accessible
 * permissions and store details.
 *
 * The JWT is attached automatically by the Apollo auth middleware from
 * localStorage's `serviceToken`. Returns `{ success, error, data }`
 * where `data` is the user object (or null on failure).
 */
import ApolloClientHexaService from 'ApolloClientHexaService';
import { AUTH_ME } from 'gql/auth';

export const getMe = async () => {
  try {
    const { data } = await ApolloClientHexaService.query({
      query: AUTH_ME,
      // Always hit the network — this is a freshness check, not a cache read.
      fetchPolicy: 'no-cache',
    });
    const user = data?.authMe || null;
    if (!user) {
      return { success: false, error: new Error('No user returned'), data: null };
    }
    return { success: true, error: false, data: user };
  } catch (error) {
    return { success: false, error, data: null };
  }
};
